var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Form',{attrs:{"title":"Images and additional logos - gallery of business images","icon":"image"}},[_c('ImageGallery',{attrs:{"object-id":_vm.branch.BusinessBranchId,"object-type":_vm.galleryImageAttachType,"fileAttachmentType":_vm.galleryImageAttachmentType,"limit":10,"altText":_vm.branch?.TradingName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }